import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';

import {
	type RemixHistoryPluginMeta,
	remixHistoryPluginKey,
} from '../pm-plugins/remix-history/remix-history-plugin';

export function makeUpdateRemixImageHistoryFieldIdCommand(options: {
	conversationId: string;
	fieldId: string;
}): EditorCommand {
	return ({ tr }) => {
		tr.setMeta(remixHistoryPluginKey, {
			type: 'updateRemixImageHistoryFieldId',
			payload: {
				conversationId: options.conversationId,
				fieldId: options.fieldId,
			},
		} satisfies RemixHistoryPluginMeta);
		return tr;
	};
}
